import { Controller } from "@hotwired/stimulus"
import M from "materialize-css"

export default class extends Controller {
    static targets = ["textarea"]

    connect() {
        this.autoResize()
    }

    // If Turbo replaces this element, call this again
    autoResize() {
        this.textareaTargets.forEach((el) => {
            M.textareaAutoResize(el)
        })
    }
}